import React from "react";
import { Col, Row } from "react-bootstrap";
// Importiamo le icone necessarie da react-icons
import { 
  FaMobileAlt,
  FaRing, 
  FaHome, 
  FaHandshake,
  FaMedal
} from "react-icons/fa";
import { GiDiploma } from "react-icons/gi";
import { IoMdBoat } from "react-icons/io";
import "./Timeline.css"; 

function Storia() {
  const timelineEvents = [
    { year: "19 Ago 2023", title: "Arrivo a Liberty Bay", desc: "Trasferimento presso le Isole Canarie", icon: <IoMdBoat /> },
    { year: "31 Ago 2023", title: "SwipeUp", desc: "Nomina a Direttore", icon: <FaMobileAlt /> },
    { year: "20 Apr 2024", title: "Premio Salvadori", desc: "Riconoscimento per l'innovazione in ambito lavorativo", icon: <FaMedal /> },
    { year: "23 Mag 2025", title: "Matrimonio", desc: "Sposato con Pedro Morales", icon: <FaRing /> },
    { year: "09 Set 2025", title: "Diploma", desc: "Istituto J. de La Torre con valutazione di 95/100", icon: <GiDiploma /> },
    { year: "Dic 2025", title: "Adozione", desc: "Famiglia Lawson", icon: <FaHome /> },
    { year: "12 Gen 2026", title: "Dimissioni SwipeUp", desc: "Cessione dell'azienda a Jess Aarons (ImSebii)", icon: <FaHandshake /> }
  ];

  return (
    <div className="storia-container">
      
      {/* --- SEZIONE BIO TESTUALE (Invariata) --- */}
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            <span className="purple">Gustavo Lawson</span>{" "}
            naque a {" "}<span className="purple">Madrid</span>.
            Suo padre{" "}
            <span className="purple">Alessandro</span>,
            venditore di telefoni presso un negozio di elettronica, sosteneva la famiglia, mentre Gustavo, fin dalla tenera età, mostrava una vivace curiosità e un'intelligenza brillante. 
            Trascorreva pomeriggi interi leggendo libri e, ispirato dal lavoro del padre, sviluppò un forte interesse per l'
            <span className="purple">informatica{" "}</span>ed l'
            <span className="purple">evoluzione tecnologica{" "}</span>grazie al lavoro del padre e visse una felice adolescenza.
            Nel <span className="purple">2022</span>, tuttavia, l'azienda per cui lavorava il padre fallì. Alessandro si trovò costretto a lavorare in una gelateria, ma l'insoddisfazione e le difficoltà economiche lo spinsero a cercare altrove.
            <br />
            <br />
            L'anno successivo, intravedendo nuove opportunità alle <span className="purple">Isole Canarie</span>, nella metropoli di <span className="purple">Liberty Bay</span> la famiglia decise di trasferirsi in cerca di fortuna.
            Qui Gustavo iniziò a costruire la sua carriera: seguendo le orme paterne, il{" "}
            <span className="purple">31 agosto 2023</span>{" "}
            vinse un concorso per diventare <span className="purple">Direttore</span> dell'azienda <span className="purple">SwipeUp</span>, specializzata in vendita e produzione di prodotti di elettronica e telefonia.
            <br />
            <br />
            Il <span className="purple">23 maggio 2025</span> si sposò con <span className="purple">Pedro Morales</span> ed ebbero 3 figli: <span className="purple">Revy De Mondre, Samu Morales e Andrea Grandi</span>, 3 mesi dopo divorziarono per dei problemi.
            Rimase sempre in buoni rapporti con il <span className="purple">padre</span> Alessandro che grazie alle sue esperienze, divenne Vice Direttore del Bistrot come Vice Direttore, Manager della Gelateria, Manager Interior Design. 
            Alessandro si diplomò il 30 agosto 2025.
            Purtroppo, ad <span className="purple">agosto 2024</span>, i suoi genitori divorziarono, purtroppo la madre abbandonò l'isola, non facendosi più sentire.
            <br />
            <br />
            Nonostante le difficoltà personali, Gustavo continuò gli studi e il <span className="purple">9 settembre 2025</span> conseguì il diploma presso l'
            <span className="purple">Istituto J. de La Torre</span> con una valutazione di 95.
            <br />
            <br />
            Desideroso di ritrovare un nucleo familiare, fece diverse domande di adozione. A <span className="purple">dicembre 2025</span>, venne adottato da{" "}
            <span className="purple">Giulia Storm e Ludy Lawson</span>: conobbe subito i suoi cinque fratelli e, in particolare, si legò molto a{" "}
            <span className="purple">Eleonora Derosa Lawson</span>.
            <br />
            <br />
            Il <span className="purple">12 gennaio 2026</span> ha ceduto l'azienda <span className="purple">SwipeUp</span> al <span className="purple">Vice Direttore Jess Aarons</span> (ImSebii).
            </p>
        </blockquote>
      </Row>

      {/* --- SEZIONE TIMELINE --- */}
      <Row className="timeline-row">
        <Col className="p-0">
          <div className="timeline-wrapper">
            <h3 className="timeline-header"><span className="purple">Timeline Eventi</span></h3>
            
            <div className="timeline-horizontal">
              {/* Nota: Nessun div "line" qui, è tutto gestito dal CSS */}
              {timelineEvents.map((item, index) => (
                <div className="timeline-item" key={index}>
                  <div className="timeline-icon-wrapper">
                    {item.icon}
                  </div>
                  <div className="timeline-content">
                    <span className="timeline-date">{item.year}</span>
                    <h5 className="timeline-title">{item.title}</h5>
                    <p className="timeline-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Col>
      </Row>

    </div>
  );
}

export default Storia;
